import { setRichTextEditorHtml } from '../components/rich-text-editor';

function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function () {
            resolve(typeof reader.result === 'string' ? reader.result : '');
        };
        reader.onerror = function () {
            reject(reader.error);
        };
        reader.readAsDataURL(file);
    });
}

function readBlobUrlAsDataUrl(blobUrl) {
    return fetch(blobUrl)
        .then(function (response) {
            return response.blob();
        })
        .then(function (blob) {
            return new Promise(function (resolve, reject) {
                const reader = new FileReader();
                reader.onload = function () {
                    resolve(typeof reader.result === 'string' ? reader.result : '');
                };
                reader.onerror = function () {
                    reject(reader.error);
                };
                reader.readAsDataURL(blob);
            });
        });
}

function imageRowsForPreviewApi(rows) {
    return (rows || []).map(function (row) {
        return {
            path: row.path,
            type: row.type,
            display_order: row.display_order,
        };
    });
}

window.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('frm_setting');
    if (!form) return;

    const copySourceSubCategoryNotMatchedMessage =
        form.dataset.copySourceSubCategoryNotMatchedMessage || '';

    const copySourceSelectorButton = form.querySelector('[data-action="open-copy-source-product-selector"]');
    const subCategory = document.getElementById('sub_category_id');
    const categoryInput = document.getElementById('category_id');
    const editOptionButtons = form.querySelectorAll('[data-action="edit-option"]');
    const detailPreviewButtons = form.querySelectorAll('[data-action="detail-preview"]');
    let copySourceSelectionToken = 0;

    const syncCategoryId = function () {
        if (!subCategory || !categoryInput) return;
        const selected = subCategory.options[subCategory.selectedIndex];
        categoryInput.value = selected ? selected.getAttribute('data-category-id') || '' : '';
    };

    const syncOptionViewRoute = function () {
        if (!subCategory) return;
        const selectedSubCategoryId = subCategory.value || '';
        editOptionButtons.forEach(function (button) {
            const routeTemplate = button.dataset.routeTemplate || '';
            if (routeTemplate && selectedSubCategoryId) {
                button.dataset.route = routeTemplate.replace(
                    '__SUB_CATEGORY_ID__',
                    selectedSubCategoryId
                );
            }
        });
    };

    const openRouteInNewTab = function (route) {
        const anchor = document.createElement('a');
        anchor.href = route;
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        anchor.click();
    };

    const triggerCopySourceSelectorModal = function (button) {
        if (!button) return;

        const modalInstanceId = button.dataset.modalInstanceId || 'admin-product-copy-source';
        const browserEventName =
            button.dataset.browserEventName || 'admin-product-copy-source-selected';

        window.dispatchEvent(
            new CustomEvent('item-selector-modal-request-open', {
                bubbles: true,
                detail: {
                    modalInstanceId: modalInstanceId,
                    listType: 'product',
                    browserEventName: browserEventName,
                },
            })
        );
    };

    const resolveSubCategoryOptionByLabel = function (label) {
        if (!subCategory || typeof label !== 'string') {
            return null;
        }

        const normalizedLabel = label.trim();
        if (normalizedLabel === '') {
            return null;
        }

        return (
            Array.from(subCategory.options).find(function (option) {
                return option.textContent.trim() === normalizedLabel;
            }) || null
        );
    };

    const setInputValue = function (selector, value) {
        const input = form.querySelector(selector);
        if (!input) return;

        input.value = value ?? '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const setCheckboxValue = function (selector, value) {
        const input = form.querySelector(selector);
        if (!input) return;

        input.checked = String(value) === '1' || value === true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const setSelectValue = function (selector, value) {
        const select = form.querySelector(selector);
        if (!select) return false;

        const normalizedValue = value == null ? '' : String(value);
        const matchedOption = Array.from(select.options).find(function (option) {
            return option.value === normalizedValue;
        });

        if (!matchedOption) {
            return false;
        }

        select.value = matchedOption.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));

        return true;
    };

    const setRichTextValue = function (inputName, value) {
        const root = form.querySelector('[data-rich-text-editor][data-input-name="' + inputName + '"]');
        if (!root) return;

        setRichTextEditorHtml(root, value);
    };

    const syncRichTextInputsForPreview = function (formEl) {
        if (!formEl) {
            return;
        }

        formEl.querySelectorAll('[data-rich-text-editor]').forEach(function (rootEl) {
            const hiddenInput = rootEl.querySelector('[data-rich-text-input]');
            const qlEditor = rootEl.querySelector('.ql-editor');
            if (!hiddenInput || !qlEditor) {
                return;
            }

            hiddenInput.value = qlEditor.innerHTML;
            hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
            hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    };

    const showCopySourceAlert = async function (message) {
        if (typeof window.showAlert === 'function') {
            await window.showAlert(message);
            return;
        }

        window.alert(message);
    };

    const closePreviewTab = function (previewTab) {
        if (previewTab && !previewTab.closed) {
            previewTab.close();
        }
    };

    const appendHiddenField = function (formEl, name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value === undefined || value === null ? '' : String(value);
        formEl.appendChild(input);
    };

    const appendNestedFormFields = function (formEl, name, value) {
        if (Array.isArray(value)) {
            value.forEach(function (item, index) {
                appendNestedFormFields(formEl, name + '[' + index + ']', item);
            });
            return;
        }

        if (value !== null && typeof value === 'object') {
            Object.keys(value).forEach(function (key) {
                appendNestedFormFields(formEl, name + '[' + key + ']', value[key]);
            });
            return;
        }

        appendHiddenField(formEl, name, value);
    };

    const submitPreviewForm = function (previewRoute, targetName, token, payload) {
        const postForm = document.createElement('form');
        postForm.method = 'POST';
        postForm.action = previewRoute;
        postForm.target = targetName;
        postForm.style.display = 'none';

        appendHiddenField(postForm, '_token', token);
        Object.keys(payload).forEach(function (key) {
            appendNestedFormFields(postForm, key, payload[key]);
        });

        document.body.appendChild(postForm);
        postForm.submit();
        postForm.remove();
    };

    const applyCopySourceProduct = async function (payload) {
        const productId = payload?.id ?? payload?.detail?.id;
        if (productId === undefined || productId === null || productId === '') {
            return;
        }

        const requestToken = ++copySourceSelectionToken;

        try {
            const productRow = await window.jpenergyFetchAdminProductById(productId);
            if (requestToken !== copySourceSelectionToken) {
                return;
            }

            const matchedSubCategoryOption = resolveSubCategoryOptionByLabel(productRow?.sub_category);

            if (!matchedSubCategoryOption) {
                await showCopySourceAlert(copySourceSubCategoryNotMatchedMessage);
                return;
            }

            subCategory.value = matchedSubCategoryOption.value;
            subCategory.dispatchEvent(new Event('change', { bubbles: true }));

            setInputValue('input[name="manufacturer_name"]', productRow?.manufacturer);
            setInputValue('input[name="model_number"]', productRow?.model_number);
            setInputValue('input[name="product_name"]', productRow?.product_name);
            setInputValue('input[name="item"]', productRow?.item);
            setCheckboxValue('input[name="easy_estimate_product"]', productRow?.easy_estimate_product);
            setSelectValue('select[name="sales_type"]', productRow?.sales_type);
            setInputValue('input[name="construction_content"]', productRow?.construction_content);
            setInputValue('input[name="cost"]', productRow?.cost_price);
            setInputValue('input[name="sell_price"]', productRow?.sell_price);
            setInputValue('input[name="list_price"]', productRow?.list_price);
            setCheckboxValue('input[name="is_open_price"]', productRow?.is_open_price);
            setCheckboxValue('input[name="suppress_new"]', productRow?.suppress_new);
            setInputValue('input[name="product_pop1"]', productRow?.product_pop1);
            setInputValue('input[name="product_pop2"]', productRow?.product_pop2);
            setInputValue('input[name="product_pop3"]', productRow?.product_pop3);
            setInputValue('input[name="product_pop4"]', productRow?.product_pop4);
            setRichTextValue('product_detail', productRow?.product_detail);
            setRichTextValue('basic_construction_content', productRow?.basic_construction_content);
            setInputValue('textarea[name="note"]', productRow?.note);
        } catch (error) {
            if (requestToken !== copySourceSelectionToken) {
                return;
            }
            const message = error && typeof error.message === 'string' ? error.message : String(error);
            await showCopySourceAlert(message);
        }
    };

    const registerCopySourceSelectionListener = function () {
        if (
            window.__jpenergyAdminProductsSettingCopySourceListenerRegistered ||
            typeof window.Livewire?.on !== 'function'
        ) {
            return;
        }

        window.__jpenergyAdminProductsSettingCopySourceListenerRegistered = true;
        window.Livewire.on('admin-product-copy-source-selected', applyCopySourceProduct);
    };

    const collectPreviewImageRowsFromFileManagersAsync = async function (formEl, baseName) {
        const rows = [];
        for (let i = 0; i < 3; i++) {
            const pathInput = formEl.querySelector('input[name="' + baseName + '[' + i + '][path]"]');
            const manager = pathInput ? pathInput.closest('[data-file-manager]') : null;
            if (!manager) {
                continue;
            }
            const typeInput = formEl.querySelector('input[name="' + baseName + '[' + i + '][type]"]');
            const orderInput = formEl.querySelector('input[name="' + baseName + '[' + i + '][display_order]"]');
            const fileInput = manager.querySelector('[data-fm-file-input]');
            const pathVal = (pathInput.value || '').trim();
            const img = manager.querySelector('[data-fm-preview-img]');
            const imgSrc = img && img.getAttribute('src') ? img.getAttribute('src').trim() : '';
            const emptyUrl = (manager.dataset.emptyPreviewUrl || '').trim();
            let path = pathVal;

            if (!path && fileInput && fileInput.files && fileInput.files[0]) {
                try {
                    path = await readFileAsDataUrl(fileInput.files[0]);
                } catch (e) {
                    path = '';
                }
            }
            if (!path && imgSrc && imgSrc !== emptyUrl) {
                if (imgSrc.indexOf('blob:') === 0) {
                    try {
                        path = await readBlobUrlAsDataUrl(imgSrc);
                    } catch (e) {
                        path = '';
                    }
                } else {
                    path = imgSrc;
                }
            }
            const orderVal =
                orderInput && String(orderInput.value || '').trim() !== ''
                    ? String(orderInput.value).trim()
                    : String(i + 1);
            rows.push({
                path: path,
                type: typeInput ? typeInput.value : null,
                display_order: orderVal,
                slotIndex: i,
            });
        }
        return rows;
    };

    if (subCategory) {
        subCategory.addEventListener('change', function () {
            syncCategoryId();
            syncOptionViewRoute();
        });
        syncCategoryId();
        syncOptionViewRoute();
    }

    const salesTypeSelect = form.querySelector('select[name="sales_type"]');
    const publicAreaRow = form.querySelector('.js-admin-product-public-area-row');

    const syncPublicAreaRowVisibility = function () {
        if (!salesTypeSelect || !publicAreaRow) {
            return;
        }
        const goodsSalesType = parseInt(String(form.dataset.goodsSalesType || '2'), 10);
        const parsed = parseInt(String(salesTypeSelect.value || ''), 10);
        const isGoodsSales = parsed === goodsSalesType;
        publicAreaRow.classList.toggle('d-none', isGoodsSales);
    };

    if (salesTypeSelect) {
        salesTypeSelect.addEventListener('change', syncPublicAreaRowVisibility);
        syncPublicAreaRowVisibility();
    }

    if (copySourceSelectorButton) {
        copySourceSelectorButton.addEventListener('click', function () {
            triggerCopySourceSelectorModal(copySourceSelectorButton);
        });
    }

    document.addEventListener('livewire:init', registerCopySourceSelectionListener);
    registerCopySourceSelectionListener();

    function bindActionButtons(buttons, openInNewTab) {
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                const route = button.dataset.route || '';
                if (!route) return;

                if (openInNewTab) {
                    openRouteInNewTab(route);
                } else {
                    window.location.href = route;
                }
            });
        });
    }

    bindActionButtons(editOptionButtons, true);

    detailPreviewButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const previewRoute = button.dataset.previewRoute || '';
            if (!previewRoute) {
                return;
            }
            const previewWindowName = 'admin-product-detail-preview-' + Date.now().toString(36);
            const previewTab = window.open('', previewWindowName);
            if (!previewTab) {
                return;
            }

            syncRichTextInputsForPreview(form);

            const areaSelect = document.getElementById('public_area');
            let areaNameFromForm = '';
            if (areaSelect) {
                const picked = Array.prototype.find.call(areaSelect.options, function (o) {
                    return o.selected;
                });
                if (picked && picked.value !== '') {
                    areaNameFromForm = String(picked.textContent || '').trim();
                }
            }

            const subCategoryEl = document.getElementById('sub_category_id');
            let subCategoryName = '';
            if (subCategoryEl && subCategoryEl.options[subCategoryEl.selectedIndex]) {
                subCategoryName = subCategoryEl.options[subCategoryEl.selectedIndex].text.trim();
            }

            const suppressCheckbox = document.getElementById('suppress_new_check');
            const suppressNew = suppressCheckbox && suppressCheckbox.checked ? 1 : 0;

            const salesTypeRaw = form.querySelector('select[name="sales_type"]')?.value;
            const salesTypeParsed = parseInt(String(salesTypeRaw ?? ''), 10);
            const salesType = salesTypeParsed === 1 || salesTypeParsed === 2 ? salesTypeParsed : null;

            const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

            Promise.all([
                collectPreviewImageRowsFromFileManagersAsync(form, 'product_images'),
                collectPreviewImageRowsFromFileManagersAsync(form, 'detail_images'),
            ])
                .then(function (pair) {
                    let previewCategoryId = null;
                    const selectedSubCategoryOption = subCategoryEl?.options[subCategoryEl.selectedIndex] ?? null;
                    const selectedCategoryId = selectedSubCategoryOption?.dataset.categoryId ?? '';
                    if (selectedCategoryId !== '') {
                        const parsedCategoryId = parseInt(String(selectedCategoryId), 10);
                        if (!Number.isNaN(parsedCategoryId)) {
                            previewCategoryId = parsedCategoryId;
                        }
                    }

                    const previewPayload = {
                        sub_category_name: subCategoryName,
                        manufacturer_name: form.querySelector('input[name="manufacturer_name"]')?.value ?? '',
                        model_number: form.querySelector('input[name="model_number"]')?.value ?? '',
                        product_name: form.querySelector('input[name="product_name"]')?.value ?? '',
                        item: form.querySelector('input[name="item"]')?.value ?? '',
                        construction_content: form.querySelector('input[name="construction_content"]')?.value ?? '',
                        area_name: areaNameFromForm,
                        sell_price: parseInt(String(form.querySelector('input[name="sell_price"]')?.value ?? '0'), 10) || 0,
                        sales_type: salesType,
                        suppress_new: suppressNew,
                        product_pop1: form.querySelector('input[name="product_pop1"]')?.value ?? null,
                        product_pop2: form.querySelector('input[name="product_pop2"]')?.value ?? null,
                        product_pop3: form.querySelector('input[name="product_pop3"]')?.value ?? null,
                        product_pop4: form.querySelector('input[name="product_pop4"]')?.value ?? null,
                        product_detail: form.querySelector('input[name="product_detail"]')?.value ?? '',
                        basic_construction_content:
                            form.querySelector('input[name="basic_construction_content"]')?.value ?? '',
                        note: form.querySelector('textarea[name="note"]')?.value ?? '',
                        product_images: imageRowsForPreviewApi(pair[0]),
                        detail_images: imageRowsForPreviewApi(pair[1]),
                    };

                    if (previewCategoryId !== null) {
                        previewPayload.category_id = previewCategoryId;
                    }

                    submitPreviewForm(previewRoute, previewWindowName, token, previewPayload);
                })
                .catch(function () {
                    closePreviewTab(previewTab);
                });
        });
    });

    form.querySelectorAll('.js-product-public-period-calendar[data-initial-empty="1"]').forEach(function (wrap) {
        var input = wrap.querySelector('input[id]');
        if (input && input._flatpickr) {
            input._flatpickr.clear();
        }
    });

    form.querySelectorAll('.js-date-trigger').forEach(function (button) {
        button.addEventListener('click', function () {
            const targetName = button.getAttribute('data-target-name');
            if (!targetName) return;

            const input = form.querySelector('input[name="' + targetName + '"]');
            if (!input) return;

            input.focus();
            if (typeof input.showPicker === 'function') {
                input.showPicker();
            }
        });
    });

    form.addEventListener('submit', function () {
        form.querySelectorAll('button[type="submit"]').forEach(function (button) {
            button.disabled = true;
        });
    });
});
